exports.getRedirectInfoForEvaluated = getRedirectInfoForEvaluated;
const helper =  require('../common/helper');

let globals = {
    apiGatewayUrl: '/notifications/apigateway/'
}

async function getRedirectInfoForEvaluated(spaceId, classId, productCode) {
    try {
        const request = {
            method: 'GET',
            url: `${globals.apiGatewayUrl}${spaceId}/class/${classId}/product/${productCode}/redirection-info-evaluated`,
            headers: {
                "Content-Type": "application/json"
            }
        }
        let response = await helper.makeRequest(request);
        return JSON.parse(response);
    } catch (error) {
        //redirect to dashboard in case of error
        window.location.href = window.location.origin
        throw error;
    }
}